import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import Layout from "antd/lib/layout";
import "antd/dist/antd.css";
import ContactSearch from "./components/ContactSearch";
import config from "./staticConfig";
import { CallerInforProvider } from "./contexts/customerProfile";
import { NoteHistoryProvider } from "./contexts/noteHistory";
import axios from "axios";
import {
  tokenRefresh,
  retrieveTokenFromParent,
  tokenRefreshingCheck,
} from "./utils/tokenHandler";

const { Content } = Layout;
const StyledLayout = styled(Layout)`
  background-color: #ffffff;
  & svg {
    & path {
      fill: ${config.themeConfig.buttonBackgroundColor} !important;
    }
  }
`;
const StyledContent = styled(Content)`
  border-radius: 16px;
  background-color: #ffffff;
  padding-left: 16px;
  //border: 2px solid black;
  max-width: 789px;
`;
const Header = styled.div`
  height: 22px;
  width: 106px;
  color: ${config.themeConfig.buttonBackgroundColor};
  //font-family: "PingFang SC";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin-top: 16px;
`;

const App: FC = () => {
  const [render, setRender] = useState<boolean>(false);

  useEffect(() => {
    if (config.tokenEnabled) {
      retrieveTokenFromParent();
      window.addEventListener(
        "message",
        (e) => {
          sessionStorage.setItem("id_token", e.data);
          setRender(true);
        },
        false
      );
    } else {
      setRender(true);
    }

    axios.interceptors.request.use(
      async (axiosConfig) => {
        try {
          let token = sessionStorage.getItem("id_token")!;
          const result = tokenRefresh(token);
          // get the latest token from session storage
          if (result) {
            await tokenRefreshingCheck(token);
          }
          token = sessionStorage.getItem("id_token")!;
          axiosConfig.headers.Authorization = `Bearer ${token}`;
        } catch (err) {
          console.error("Add token to axios header error", err);
        }
        return axiosConfig;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }, []);

  if (!render) {
    return <></>;
  } else {
    return (
      <CallerInforProvider>
        <NoteHistoryProvider>
          <StyledLayout>
            <StyledContent>
              <Header>Contact notes</Header>
              <ContactSearch></ContactSearch>
            </StyledContent>
          </StyledLayout>
        </NoteHistoryProvider>
      </CallerInforProvider>
    );
  }
};

export default App;
